import React from 'react'
import { useRouter } from 'next/router'

import { historyUtils } from '@wartek-id/toolbox-helper'
import {
  HeaderBar,
  HeaderBarLeftAction,
  HeaderBarRightAction,
  HeaderBarTitle,
} from '@wartek-id/header-bar'
import { Icon } from '@wartek-id/icon'
import { Text } from '@wartek-id/text'

import BuktiKaryaBlock from '../components/revamp/BuktiKaryaBlock'
import { PageContainer, DesktopPageHeader } from 'components/ResponsiveLayout'
import { useIdePraktikDesktopView } from 'app/InspirationPage/hooks/useIdePraktikDesktopView'
import { useAPIGetCategory } from 'api/inspirations/useAPIInspirations'

import type { BreadcrumbItemDef } from 'components/ResponsiveLayout'
import type { FC } from 'react'

const HELPDESK_LINK = 'https://pusatinformasi.guru.kemdikbud.go.id'

interface BuktiKaryaProps {
  categorySlug?: string
}

const BuktiKarya: FC<BuktiKaryaProps> = ({ categorySlug }) => {
  const { isDesktop } = useIdePraktikDesktopView()
  const { data: categoryData } = useAPIGetCategory(categorySlug, {
    enabled: isDesktop && !!categorySlug,
  })

  if (isDesktop) {
    const breadcrumbItems: BreadcrumbItemDef[] = [
      { label: 'Ide Praktik', href: '/ide-praktik' },
    ]

    if (categorySlug && categoryData?.data) {
      breadcrumbItems.push({
        label: 'Kategori',
        href: '/ide-praktik/kategori',
      })
      breadcrumbItems.push({
        label: categoryData.data.titleWithoutEmoji || categoryData.data.title,
        href: `/ide-praktik/kategori/${categorySlug}`,
      })
    }

    breadcrumbItems.push({ label: 'Bukti Karya terpilih', href: null })

    return (
      <div className="min-h-screen bg-surface-subdued">
        <DesktopPageHeader
          breadcrumbItems={breadcrumbItems}
          navLinks={[{ label: 'Bantuan', href: HELPDESK_LINK, external: true }]}
        />
        <main>
          <div className="bg-white border-b">
            <PageContainer>
              <Text variant="heading-lg">Bukti Karya terpilih</Text>
            </PageContainer>
          </div>
          <PageContainer>
            <BuktiKaryaBlock categorySlug={categorySlug} isDesktop />
          </PageContainer>
        </main>
      </div>
    )
  }

  return (
    <>
      <PageHeader />
      <div className="mt-[3.5rem] px-4 py-3 bg-gray-10 h-full--without-header">
        <BuktiKaryaBlock categorySlug={categorySlug} />
      </div>
    </>
  )
}

type PageHeaderProps = {
  title?: string
  onBack?: () => void
}

const PageHeader = ({ onBack }: PageHeaderProps) => {
  const router = useRouter()

  const handleBack = () => {
    historyUtils.backToApp(router.back)
    onBack?.()
  }

  return (
    <HeaderBar fixed className="z-10 py-[1px]">
      <HeaderBarLeftAction
        icon={
          <Icon as="i" color="default">
            arrow_back
          </Icon>
        }
        onClick={handleBack}
      />
      <HeaderBarTitle>Bukti Karya terpilih</HeaderBarTitle>
      <HeaderBarRightAction />
    </HeaderBar>
  )
}

export default BuktiKarya
